<template>
  <div>
    <filter-control label="Filter templates" v-model="filter"></filter-control>
    <table class="table cells-top">
      <thead>
        <table-header
          :current-sort-field="sortField"
          @sort-click="sortClicked"
        ></table-header>
      </thead>
      <tbody>
        <table-row
          v-for="(template, index) in templates"
          :index="index"
          :key="template.systemName"
          :template="template"
          @link="linkTemplate"
          @unlink="unlinkTemplate"
        ></table-row>
      </tbody>
    </table>
    <pager
      :count="pages"
      :current-page="currentPage"
      @page-click="pageClicked"
    ></pager>
  </div>
</template>
<script>
import TableHeader from "@/components/templates/TableHeader.vue";
import TableRow from "@/components/templates/TableRow.vue";
import Pager from "@/components/common/pagination/Pager.vue";
import FilterControl from "@/components/common/filtering/FilterControl.vue";
import templates from "@/services/sharedo/templatesService";
import linkedTemplates from "@/services/word/linkedTemplatesService";
import { direction } from "@/util/sort";
import { withErrorHandling } from "@/util/sharedoUtil";
import global from "@/global";

const loadTemplates = async function(goToStart = false) {
  this.logDebug("Loading templates.");
  const opts = {
    filter: this.filter,
    sort: {
      by: this.sortField,
      direction: this.sortDirection,
    },
    paging: {
      page: goToStart ? 1 : this.currentPage,
      pageSize: global.defaultPageSize,
    },
  };

  try {
    const result = await templates.get(opts);

    this.pages = Math.ceil(result.totalCount / global.defaultPageSize);
    this.templates = result.results;
    if (goToStart) {
      this.currentPage = 1;
    }

    this.logInfo("Loaded templates.", { templates: result });
  } catch (error) {
    this.LogError("Unable to load templates.", { error });
    this.$store.commit("error", { message: "Unable to load templates." });
  }
};

const sortClicked = async function(args) {
  this.sortField = args.field;
  this.sortDirection = args.direction;
  await this.loadTemplates();
};

const pageClicked = async function(pageNo) {
  this.currentPage = pageNo;
  await this.loadTemplates();
};

const linkTemplate = async function(template) {
  await linkedTemplates.link(template.systemName);

  const currentLinkedTemplates = await linkedTemplates.get();
  this.$store.commit("currentTemplates", { templates: currentLinkedTemplates });
  this.logInfo("Template linked.", { template });
};

const unlinkTemplate = async function(template) {
  await linkedTemplates.unlink(template.systemName);

  const currentLinkedTemplates = await linkedTemplates.get();
  this.$store.commit("currentTemplates", { templates: currentLinkedTemplates });
  this.logInfo("Template unlinked.", { template });
};

const data = function() {
  return {
    filter: "",
    sortField: "title",
    sortDirection: direction.ASCENDING,
    pages: 0,
    currentPage: 1,
    templates: [],
  };
};

const mounted = async function() {
  await this.loadTemplates();
};

export default {
  components: { TableHeader, TableRow, Pager, FilterControl },
  data,
  watch: {
    filter: async function() {
      await this.loadTemplates(true);
    },
  },
  mounted,
  methods: {
    loadTemplates: withErrorHandling(loadTemplates),
    sortClicked,
    pageClicked,
    linkTemplate,
    unlinkTemplate,
  },
};
</script>
